import { VoucherHolderType } from "@nkr/enums/voucher-holder-type";
import { VoucherHolderSelfRegistrationStep } from "@nkr/enums/voucher-holder-selfreg-step";


export interface IVoucherDonor {
    id: number,
    alias: string,
    donorStatus: string,
    isComplete: boolean,
    voucherHolders: IVoucherHolder[]
}

export interface IVoucherHolder {
    id: number,
    donorId: number,
    editKey: string,
    firstName: string,
    lastName: string,
    birthDate: Date,
    phoneNumberPrimary: string,
    status: string,
    type: VoucherHolderType,
    currentSelfRegistrationStep: VoucherHolderSelfRegistrationStep,
    isComplete: boolean
}